import types from '../types/types';

const initialState = {
  orderId: null,
};
const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.setOrderId:
      return {
        ...state,
        orderId: action.orderId,
      };
    default:
      return state;
  }
};
export default orderReducer;
